import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeatErrorView = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 124,
	height: 107,
	viewBox: "0 0 124 107",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M78.3577 97.4096H32.9454C31.9936 97.4096 31.2148 96.6308 31.2148 95.679V54.2712C31.2148 53.3194 31.9936 52.5405 32.9454 52.5405H78.3577C79.3096 52.5405 80.0884 53.3194 80.0884 54.2712V95.679C80.0884 96.6308 79.3096 97.4096 78.3577 97.4096Z",
			fill: "#CDD3DD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M80.0884 54.2701V58.1431H31.2148V54.2701C31.2148 53.3189 31.9933 52.5396 32.9454 52.5396H78.3578C79.3099 52.5396 80.0884 53.3189 80.0884 54.2701Z",
			fill: "#E8F6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.8132 55.4896C35.8132 56.2271 35.2154 56.8249 34.4779 56.8249C33.7404 56.8249 33.1426 56.2271 33.1426 55.4896C33.1426 54.7521 33.7404 54.1543 34.4779 54.1543C35.2154 54.1543 35.8132 54.7521 35.8132 55.4896Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.1267 55.4896C40.1267 56.2271 39.5289 56.8249 38.7914 56.8249C38.0539 56.8249 37.4561 56.2271 37.4561 55.4896C37.4561 54.7521 38.0539 54.1543 38.7914 54.1543C39.5289 54.1543 40.1267 54.7521 40.1267 55.4896Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M44.4372 55.4896C44.4372 56.2271 43.8394 56.8249 43.1019 56.8249C42.3645 56.8249 41.7666 56.2271 41.7666 55.4896C41.7666 54.7521 42.3645 54.1543 43.1019 54.1543C43.8394 54.1543 44.4372 54.7521 44.4372 55.4896Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M83.6985 106.675H38.2863C37.3344 106.675 36.5557 105.896 36.5557 104.944V63.5363C36.5557 62.5845 37.3344 61.8057 38.2863 61.8057H83.6985C84.6504 61.8057 85.4292 62.5845 85.4292 63.5363V104.944C85.4292 105.896 84.6504 106.675 83.6985 106.675Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M85.4292 63.5353V67.4083H36.5557V63.5353C36.5557 62.5841 37.3342 61.8047 38.2862 61.8047H83.6986C84.6507 61.8047 85.4292 62.5841 85.4292 63.5353Z",
			fill: "#E8F6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.155 64.7547C41.155 65.4922 40.5572 66.0901 39.8197 66.0901C39.0823 66.0901 38.4844 65.4922 38.4844 64.7547C38.4844 64.0173 39.0823 63.4194 39.8197 63.4194C40.5572 63.4194 41.155 64.0173 41.155 64.7547Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M45.4675 64.7547C45.4675 65.4922 44.8697 66.0901 44.1322 66.0901C43.3947 66.0901 42.7969 65.4922 42.7969 64.7547C42.7969 64.0173 43.3947 63.4194 44.1322 63.4194C44.8697 63.4194 45.4675 64.0173 45.4675 64.7547Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.779 64.7547C49.779 65.4922 49.1812 66.0901 48.4437 66.0901C47.7063 66.0901 47.1084 65.4922 47.1084 64.7547C47.1084 64.0173 47.7063 63.4194 48.4437 63.4194C49.1812 63.4194 49.779 64.0173 49.779 64.7547Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M117.767 74.9926H72.3547C71.4029 74.9926 70.624 74.2139 70.624 73.2619V31.8541C70.624 30.9023 71.4029 30.1235 72.3547 30.1235H117.767C118.719 30.1235 119.498 30.9023 119.498 31.8541V73.2619C119.498 74.2139 118.719 74.9926 117.767 74.9926Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 70,
			y: 30,
			width: 50,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M70.624 30.0874H119.498V35.6909H70.624V30.0874Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M119.498 31.8185V35.6915H70.624V31.8185C70.624 30.8673 71.4025 30.0879 72.3546 30.0879H117.767C118.719 30.0879 119.498 30.8673 119.498 31.8185Z",
				fill: "#CDD3DD"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M75.1814 33.0384C75.1814 33.7759 74.5835 34.3738 73.8461 34.3738C73.1086 34.3738 72.5107 33.7759 72.5107 33.0384C72.5107 32.3009 73.1086 31.7031 73.8461 31.7031C74.5835 31.7031 75.1814 32.3009 75.1814 33.0384Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.4939 33.0384C79.4939 33.7759 78.896 34.3738 78.1586 34.3738C77.4211 34.3738 76.8232 33.7759 76.8232 33.0384C76.8232 32.3009 77.4211 31.7031 78.1586 31.7031C78.896 31.7031 79.4939 32.3009 79.4939 33.0384Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M83.8054 33.0384C83.8054 33.7759 83.2076 34.3738 82.4701 34.3738C81.7326 34.3738 81.1348 33.7759 81.1348 33.0384C81.1348 32.3009 81.7326 31.7031 82.4701 31.7031C83.2076 31.7031 83.8054 32.3009 83.8054 33.0384Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 82.5761H101.728V80.5459H91.0693V82.5761Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 85.5937H121.426V84.644H91.0693V85.5937Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 91.0863H122.441V90.1367H91.0693V91.0863Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 93.833H123.771V92.8833H91.0693V93.833Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 96.5786H110.937V95.6289H91.0693V96.5786Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.0693 88.3397H123.771V87.3901H91.0693V88.3397Z",
			fill: "#EEF1F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.1426 35.0087H42.6513V32.9785H33.1426V35.0087Z",
			fill: "#C3E4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.1426 38.0277H60.2242V37.0781H33.1426V38.0277Z",
			fill: "#D6EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.1426 43.518H61.1298V42.5684H33.1426V43.518Z",
			fill: "#D6EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.1426 46.2645H53.7589V45.3149H33.1426V46.2645Z",
			fill: "#D6EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.1426 40.7724H62.3157V39.8228H33.1426V40.7724Z",
			fill: "#D6EEFF"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask1",
					"mask-type": "alpha",
					maskUnits: "userSpaceOnUse",
					x: 52,
					y: 36,
					width: 51,
					height: 65,
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M52.8486 36.0361H102.157V100.752H52.8486V36.0361Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask1)",
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M100.652 100.752H54.3538C53.5259 100.752 52.8486 100.075 52.8486 99.2473V37.541C52.8486 36.7133 53.5259 36.0361 54.3538 36.0361H100.652C101.48 36.0361 102.157 36.7133 102.157 37.541V99.2473C102.157 100.075 101.48 100.752 100.652 100.752Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 64.132H97.0019V62.9336H66.0273V64.132Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 66.6379H87.8484V65.4395H66.0273V66.6379Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 95.1347H87.177V93.4868H66.0273V95.1347Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M59.5523 67.7822C57.9041 67.7822 56.5557 66.434 56.5557 64.7861C56.5557 63.1383 57.9041 61.79 59.5523 61.79C61.2004 61.79 62.549 63.1383 62.549 64.7861C62.549 66.434 61.2004 67.7822 59.5523 67.7822Z",
					fill: "#E4E8EE",
					stroke: "#E4E8EE",
					strokeWidth: .531397
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M59.5523 87.6983C57.9041 87.6983 56.5557 86.35 56.5557 84.7022C56.5557 83.0542 57.9041 81.7061 59.5523 81.7061C61.2004 81.7061 62.549 83.0542 62.549 84.7022C62.549 86.35 61.2004 87.6983 59.5523 87.6983Z",
					fill: "#E4E8EE",
					stroke: "#E4E8EE",
					strokeWidth: .531397
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M59.5523 77.7417C57.9041 77.7417 56.5557 76.3935 56.5557 74.7456C56.5557 73.0978 57.9041 71.7495 59.5523 71.7495C61.2004 71.7495 62.549 73.0978 62.549 74.7456C62.549 76.3935 61.2004 77.7417 59.5523 77.7417Z",
					fill: "#E4E8EE",
					stroke: "#E4E8EE",
					strokeWidth: .531397
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 74.0906H97.0019V72.8921H66.0273V74.0906Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 76.5969H87.8484V75.3984H66.0273V76.5969Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 84.0496H97.0019V82.8511H66.0273V84.0496Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 86.5554H87.8484V85.3569H66.0273V86.5554Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M56.5527 53.5731L58.7522 55.3118L62.6507 50.8042",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56.5527 53.5731L58.7522 55.3118L62.6507 50.8042",
					stroke: "#E4E8EE",
					strokeWidth: .797096
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M56.5527 43.6146L58.7522 45.3532L62.6507 40.8457",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56.5527 43.6146L58.7522 45.3532L62.6507 40.8457",
					stroke: "#E4E8EE",
					strokeWidth: .797096
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 42.273H97.0019V40.7573H66.0273V42.273Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 45.442H87.8484V43.9263H66.0273V45.442Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M64.7861 41.5145H98.2397H64.7861Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.7861 41.5145H98.2397",
					stroke: "#E4E8EE",
					strokeWidth: .265699
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M64.7861 44.6844H89.0278H64.7861Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.7861 44.6844H89.0278",
					stroke: "#E4E8EE",
					strokeWidth: .265699
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 52.2316H97.0019V50.7158H66.0273V52.2316Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M66.0273 55.3995H87.8484V53.8838H66.0273V55.3995Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M64.7861 51.4739H98.2397H64.7861Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.7861 51.4739H98.2397",
					stroke: "#E4E8EE",
					strokeWidth: .265699
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M64.7861 54.6419H89.0278H64.7861Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.7861 54.6419H89.0278",
					stroke: "#E4E8EE",
					strokeWidth: .265699
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M58.1973 59.0614H96.6276H58.1973Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.1973 59.0614H96.6276",
					stroke: "#E4E8EE",
					strokeWidth: .265699
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M59.5521 92.0054V96.6176V92.0054Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.5521 92.0054V96.6176",
					stroke: "#E4E8EE",
					strokeWidth: .797096
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M57.2451 94.3109H61.8582H57.2451Z",
					fill: "#E4E8EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M57.2451 94.3109H61.8582",
					stroke: "#E4E8EE",
					strokeWidth: .797096
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 48.4218,
					cy: 47.4218,
					r: 45.4218,
					fill: "#CDD3DD"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask2",
					"mask-type": "alpha",
					maskUnits: "userSpaceOnUse",
					x: 4,
					y: 3,
					width: 88,
					height: 88,
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 48.4212,
						cy: 47.4217,
						r: 43.4622,
						fill: "#F8F9FB"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask2)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							width: 93.6272,
							height: 94.0068,
							transform: "translate(3 -0.528809)",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 12.6294,
							width: 9.10967,
							height: 9.10967,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 50.8384,
							width: 9.10967,
							height: 9.10967,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 77.5361,
							width: 9.10967,
							height: 9.10967,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 26.293,
							width: 9.10967,
							height: 9.10967,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 12.6294,
							width: 33.1491,
							height: 3.54265,
							rx: .506093,
							fill: "#CDD3DD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 50.8384,
							width: 33.1491,
							height: 3.54265,
							rx: .506093,
							fill: "#CDD3DD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 77.5361,
							width: 33.1491,
							height: 3.54265,
							rx: .506093,
							fill: "#CDD3DD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 26.293,
							width: 33.1491,
							height: 3.54265,
							rx: .506093,
							fill: "#CDD3DD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 6.0498,
							width: 33.1491,
							height: 2.65699,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 44.2598,
							width: 33.1491,
							height: 2.65699,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 12.8691,
							y: 70.9556,
							width: 33.1491,
							height: 2.65699,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 18.1948,
							width: 25.6842,
							height: 3.54265,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 56.4058,
							width: 25.6842,
							height: 3.54265,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 83.1025,
							width: 25.6842,
							height: 3.54265,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 23.75,
							y: 31.8604,
							width: 25.6842,
							height: 3.54265,
							rx: .506093,
							fill: "#EEF1F6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 68.4131,
							y: 15.4131,
							width: 15.5624,
							height: 3.54265,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 68.4131,
							y: 53.6221,
							width: 15.5624,
							height: 3.54265,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 68.4131,
							y: 80.3179,
							width: 15.5624,
							height: 3.54265,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 68.4131,
							y: 29.0767,
							width: 15.5624,
							height: 3.54265,
							rx: .506093,
							fill: "#A8B1BD"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 23.8901H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 62.1001H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 88.7959H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 37.5547H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 10.2246H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 48.4355H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 75.1313H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 23.8901H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 62.1001H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10.9707 88.7959H85.8724",
							stroke: "#E4E8EE",
							strokeWidth: .253046
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.0285 81.4569L76.7644 80.721L80.4085 83.0384L100.493 103.122C101.095 103.725 101.095 104.702 100.493 105.304C99.8901 105.907 98.9134 105.907 98.3109 105.304L78.3227 85.3158L76.0285 81.4569Z",
			fill: "#CDD3DD"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d",
			x: 51.8364,
			y: 35.4035,
			width: 51.333,
			height: 66.7404,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .37957 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .506093 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.341176 0 0 0 0 0.4 0 0 0 0 0.458824 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d",
			x: .469535,
			y: .734768,
			width: 95.9046,
			height: 95.9046,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1.26523 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.26523 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.341176 0 0 0 0 0.4 0 0 0 0 0.458824 0 0 0 0.16 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgBeatErrorView);
export { ForwardRef as ReactComponent };
